export default __webpack_public_path__ + "7276b53c6200dc7f42d7953f4ae90e2b.png";